var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-form-select',{attrs:{"options":_vm.langs,"value-field":"key","text-field":"value"},on:{"change":_vm.handleChange},model:{value:(_vm.selectedLang),callback:function ($$v) {_vm.selectedLang=$$v},expression:"selectedLang"}})}
var staticRenderFns = []

export { render, staticRenderFns }